import React from 'react';
import { createRoot } from 'react-dom/client';
import Select, { components } from 'react-select';

import './LocationsSelector.scss';
import { withTranslation } from 'react-i18next';

const { Option } = components;
const IconOption = (props) => (
    <Option {...props}>
        <i className={props.data.type == 'locations_groups' ? "fas fa-layer-group pr-1" : ''}></i>
        <span className={props.data.type == 'locations_groups' ? "font-weight-bold" : ''}>{props.data.label} {props.selectProps.displayPax && props.data.max_pax > 0 && (<span>(Max PAX : {props.data.max_pax})</span>)}</span>
    </Option>
);

class LocationsSelectorComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isLoaded: false,
            display_select: false,
            locations: [],
            locations_groups: [],
            locations_selected: [],
            selectLocationsValue: null,
            menuIsOpen: false
        };

        this.selectStyles = {
            menu: base => ({
                ...base,
                marginTop: 0,
                'z-index': 10
            })
        }

        if(this.props.windowId && this.props.windowId != '') {
            window.allLocationsSelectors[this.props.windowId] = this;
        }
    }

    componentDidMount() {
        if (this.props.ajax_load) {
            let url = ENV.base_lang_url + "myspace/providers//ajaxGetter/";
            let methode = this.props.multiple ? 'get_locations_and_groups_by_hotel' : 'get_locations_by_hotel';
            const params = new URLSearchParams();
            params.append('hotels_id', this.props.hotels_id);
            fetch(url + methode, {
                method: 'POST',
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: params.toString()
            })
                .then(rtn => rtn.json())
                .then(result => {
                    this.setState({
                        locations: result,
                        isLoaded: true
                    }, () => this.handleLoad());
                })
                .catch(errorMsg => { console.log(errorMsg); });
        } else {
            this.setLocationsFromProps();
        }
    }


    componentDidUpdate() {
        this.setLocationsFromProps();
    }

    handleClickDisplaySelect = () => {
        this.setState({
            display_select: true,
            menuIsOpen: true
        });
    };

    handleCloseDisplaySelect = () => {
        this.setState({
            display_select: false,
            menuIsOpen: false
        });
    };

    handleChange = () => {
        if (this.props.onChange) {
            this.props.onChange(this.state.locations_selected);
        }
    };

    handleLoad = () => {
        if (this.props.onLoad) {
            this.props.onLoad();
        }

        let locations_selected = this.state.locations.filter((loc) => {
            return this.props.defaultValue.includes(loc.value.toString()) && loc.type == 'locations';
        });
        this.setState({
            locations_selected: locations_selected
        }, () => this.handleChange());
    };

    onInputChange = (options, { action }) => {
        if (action === "menu-close") {
            this.setState({ menuIsOpen: false });
        }
    };

    onFocus = e => {
        this.setState({ menuIsOpen: true });
    };

    setLocationsFromProps() {
        if (!this.props.ajax_load && !this.state.isLoaded && this.props.locations_loaded.length > 0) {
            this.setState({
                locations: this.props.locations_loaded,
                isLoaded: true
            }, () => this.handleLoad());
        }
    }

    addLocations(event) {
        if (event) {
            let locations_selected = this.props.multiple ? this.state.locations_selected : [];

            if (event.type == 'locations') {
                locations_selected = locations_selected.concat(event);
            } else {

                let locs = this.state.locations.filter((loc) => {
                    return event.locations_ids.includes(parseInt(loc.value)) && loc.type == 'locations';
                });
                locations_selected = locations_selected.concat(locs);
            }

            locations_selected = [
                ...new Map(locations_selected.map((item) => [item.value, item])).values(),
            ];
            this.setState({
                locations_selected: locations_selected,
                selectLocationsValue: null,
                display_select: false
            }, () => this.handleChange());
        }
    }

    addGroups() {
        let groups = this.selectGroups.current.getValue();
        let all_locations_id = [];
        let all_locations = [];
        for (let group of groups) {
            all_locations_id = all_locations_id.concat(group.locations);
        }

        for (let loc of this.state.locations) {
            if (all_locations_id.includes(parseInt(loc.value))) {
                all_locations.push(loc);
            }
        }

        let locations_selected = this.state.locations_selected;
        locations_selected = locations_selected.concat(all_locations);
        locations_selected = [
            ...new Map(locations_selected.map((item) => [item.value, item])).values(),
        ];

        this.setState({
            locations_selected: locations_selected
        }, () => this.handleChange());
        this.selectGroups.current.clearValue();
    }

    removeLocation(location_id) {
        let locations_selected = this.state.locations_selected;
        locations_selected = locations_selected.filter((item) => {
            return parseInt(item.value) != parseInt(location_id);
        });
        this.setState({
            locations_selected: locations_selected
        }, () => this.handleChange());

    }

    setNewDefaultValue(locations_ids) {
        let locs = this.state.locations.filter((loc) => {
            return locations_ids.includes(loc.value) && loc.type == 'locations';
        });
        this.setState({
            locations_selected: locs
        }, () => this.handleChange());
    }


    render() {
        const { t } = this.props;
        const gctrad = t;
        let required_attributes = {};
        if (this.props.required) {
            required_attributes['data-parsley-validate-if-empty'] = true;
            required_attributes['data-parsley-min'] = 1;
            required_attributes['data-parsley-errors-container'] = "#locations_selector_errors";
            required_attributes['data-parsley-error-message'] = gctrad('[:myspace] Veuillez choisir au moins un espace');
        }
        return (
            <div className={'react-locations-selector bg-white border-0 ' + (this.state.locations_selected.length > 0 ? 'text-gc-green' : 'text-gc-orange')}>

                <div className={!this.state.display_select ? 'float-right' : 'd-none'}>
                    <div className="row justify-content-around">
                        <div className="col text-center">
                            <button type='button' className='btn small btn-link' onClick={() => this.handleClickDisplaySelect()}><i className="fas fa-plus"></i> {this.props.label_btn_associer ?? gctrad('[:myspace] Associer un espace')}</button>
                        </div>
                    </div>
                </div>

                {this.props.display_label && (
                    <label>{this.props.label}</label>
                )}
                <div>
                    <div className={this.state.display_select ? '' : 'd-none'}>
                        <Select options={this.state.locations}
                            onChange={(event) => { this.addLocations(event) }}
                            onInputChange={this.onInputChange}
                            onFocus={this.onFocus}
                            value={this.state.selectLocationsValue}
                            components={{ Option: IconOption }}
                            placeholder={this.props.placeholder ?? gctrad('Sélectionnez un espace')}
                            displayPax={this.props.displayPax}
                            classNamePrefix="react-select"
                            menuIsOpen={this.state.menuIsOpen}
                            styles={this.selectStyles}
                        >
                        </Select>
                    </div>

                    <div className='selected'>
                        {this.state.locations_selected.length > 0 ?

                            this.state.locations_selected.map((item) => {
                                return (
                                    <span key={item.value} className="badge badge-location-label m-1">
                                        <span className='location-label'>{item.label}</span> <i className="fas fa-times cursor-pointer" onClick={() => this.removeLocation(item.value)}></i>
                                        <input type="hidden" name={this.props.name} value={item.value} />
                                    </span>
                                )
                            }) : (
                                <span className="text-gc-orange font-weight-bold">
                                    {gctrad('[:myspace] Aucune salle sélectionnée')}
                                </span>
                            )

                        }

                        <input
                            type="hidden"
                            value={this.state.locations_selected.length}
                            required={true}
                            {...required_attributes}
                        />

                    </div>
                </div>
            </div>
        )
    }
}

const LocationsSelector = withTranslation()(LocationsSelectorComponent);
export default LocationsSelector;

if(typeof window.allLocationsSelectors == 'undefined') {
    window.allLocationsSelectors = {};
}

LocationsSelector.defaultProps = {
    ajax_load: true,
    locations_loaded: [],
    defaultValue: [],
    required: false,
    display_label: false
};